import React from 'react'
import { Box, Heading } from '@theme-ui/components'
import ContactDetails from '../../../General/ContactDetails'
import CloudinaryImage from '../../../General/CloudinaryImage'
import MultiButtons from '../../../General/MultiButtons/MultiButtonsV1'
import Copyright from '../../../General/Copyright'
import GonationLogoPowered from '../../../General/GonationLogoPowered'
import SocialIcons from '../../../General/SocialIcons/SocialIconsV1'
import LocationSwitcher from '../../../LocationSwitchers/v1/LocationSwitcher'
import combineSocialLinks from '../../../../helpers/combineSocialLinks'
import HoursDisplay from '../../../Hours/HoursDisplay'

export default function Index({
  businessData,
  configData,
  locations,
  navLinks,
  locationIndex,
  isMultiLocationSite,
  options,
  variantName
}) {
  // === Destructing ===
  const {
    avatar: { imageBaseUrl, imagePrefix },
    name,
    street,
    city,
    state,
    zip,
    links,
    slug,
    hours
  } = businessData

  const { containerStyles, linkedin, pinterest, email } = options

  //=== Data Transformations ===

  const variant = variantName ? variantName : 'footerV7'
  const styles = containerStyles ? JSON.parse(containerStyles) : {}
  const configuredSocialLinks =
    linkedin || pinterest ? combineSocialLinks(links, linkedin?.[locationIndex], pinterest) : links
  return (
    <Box
      sx={styles}
      style={{
        backgroundColor: options.backgroundColor ? options.backgroundColor : ''
      }}
      variant={`${variant}.container`}
      className="container footerContainer footer"
    >
      <Box variant={`${variant}.logoContainer`} className="section logoContainer">
        <CloudinaryImage
          variant={`${variant}.logo`}
          className="logo"
          imageBaseUrl={imageBaseUrl}
          imagePrefix={imagePrefix}
        />

        {isMultiLocationSite && (
          <LocationSwitcher className="locationSwitcher" businessData={businessData} locations={locations} />
        )}

        {true && <HoursDisplay hours={hours} variant={variant} />}

        <Box variant={`${variant}.logoContainerFooter`}>
          <GonationLogoPowered />
          <Copyright name={name} />
        </Box>
      </Box>
      <Box variant={`${variant}.buttonsContainer`} className="section buttonsContainer">
        <MultiButtons isMultiLocationSite={isMultiLocationSite} links={navLinks} city={city} />
      </Box>
      <Box variant={`${variant}.contactContainer`} className="section contactContainer">
        <Heading variant={`${variant}.heading`}>Contact</Heading>
        <ContactDetails
          phone={businessData.phone}
          address={{ name, street, city, state, zip }}
          alternativeGoogleMapLink={configData.alternativeGoogleMapLink}
          email={email?.[locationIndex] ?? links?.email ?? ''}
        />
        <SocialIcons slug={slug} links={configuredSocialLinks} />
      </Box>
    </Box>
  )
}
